// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"Xz-z","smallCardRow":"Yz-z","largeCardRow":"Zz-z","productSearchRow":"_z-z","curatedRow":"aA-z"};